import axios from "axios";
import JSONbig from 'json-bigint'
export const tagTree = (data) => {
    return axios.request({
        method: "GET",
        url: "/api/directive/tagTree",
        params: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
};
//稽查诊断 获取分类
export const jczdGetTagTree = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/category/categoryTree",
        params: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
};
//稽查诊断 获取政策诊断相关分类
export const zczdGetTagTree = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/home/myPolicy",
        params: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
};

//相应答疑的左侧列表接口
export const xydyGetDataTree = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/dayi/dayiCategoryNav",
        params: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
}

export const dayiDetail = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg//dayi/detail",
        data: data,
        headers: { 'content-Type': 'application/json' },
    });
}

export const getDaYiData1 = (data) => {
    return axios.request({
        method: "post",
        url: '/zsg/dayi/categoryTree',
        dparamsata: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    })
  }

//答疑热点统计
export const xydyGetHotTongJi = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/dayi/dayiHot",
        data: data,
        headers: { "content-type": "application/json" },
    });
}
//答疑热点时间
export const xydyGetYearNav = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/dayi/dayiYearNav",
        data: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
}

//sse记录
export const sseHistory = (data) => {
    let tUrl = '/sseAI/round/history?auth_sign=eJw1jN0KgjAARt9l19Hm3LQJXZQlUgr9aFB3rrkcmplpWtG7J2KX3*Gc7wMCbz9*xiWwAB4jMOr3Q6RRUSjRwVZ-Zz6nyctxgsOsaQdDiTivlFR9yASVmtQl4RRFjGB2RsaEI4IIphJx-n9Vl05Ok60ywqUPd3N7swrWeQ2Vd5cNLxehfYKuU9-cYwv1NCPTIazUNQaWZmKGqYkNZprk*wMRkDZ6&auth_ts=1729257269774&auth_code=zsdy'
    return axios.request({
        method: "POST",
        url: tUrl,
        data: data,
        headers: { "content-type": "application/json" },
    });
}


export const tagTreeCache = (data) => {
    return axios.request({
        method: "GET",
        url: "/api/directive/tagTreeCache",
        params: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
};

export const dictionaryDataList = (data) => {
    return axios.request({
        method: "GET",
        url: "/api/directive/dictionaryDataList",
        params: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
};

export const getRelated = (data) => {
    return axios.request({
        method: "get",
        url: "/cms/related",
        params: data,
        headers: { "content-type": "application/x-www-form-urlencoded" },
    });
};
export const dataSearch = (data) => {
    return axios.request({
        method: "POST",
        url: "/cms/data/search",
        data: data,
        headers: { "content-type": "application/json" },
    });
};

export const cmsDataGetTagNames = (data) => {
    return axios.request({
        method: "GET",
        url: '/cms/data/getTagNames',
        params: data,
        headers: { 'content-type': 'application/x-www-form-urlencoded' }
    })
}

export const Cmsdetail = (data) => {
    return axios.request({
        method: "POST",
        url: "/cms/detail",
        data: data,
        headers: { "content-type": "application/json" },
    });
};

export const HomeLaw = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/home/law",
        data: data,
        headers: { "content-type": "application/json" },
        transformResponse: [
            function(res) {
                let json = JSON.parse(JSON.stringify(JSONbig.parse(res)));
                return json;
            }
        ],
    });
};


export const lawSearch = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/law/search",
        data: data,
        headers: { "content-type": "application/json" },
    });
};

export const list = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/law/search",
        data: data,
        headers: { "content-type": "application/json" },
    });
};

export const HomeAnalyzeKeyword = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/home/analyzeKeyword",
        data: data,
        headers: { "content-type": "application/json" },
    });
};

export const keyLenovo = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/home/searchKeyword",
        data: data,
        headers: { "content-type": "application/json" },
    });
};

export const tal = (data) => {
    return axios.request({
        method: "POST",
        url: "/zsg/law/aggs",
        data: data,
        headers: { "content-type": "application/json" },
    });
};

// 登录
export const login = (data) => {
    return axios.request({
        method: "get",
        url: '/zsg/user/detail',
        params: data,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
}

// 购买列表
export const orderList = (data) => {
    return axios.request({
        method: "POST",
        url: '/shopApi/order/list',
        params: data,
        headers: { 'content-type': 'application/x-www-form-urlencoded' }
    })
}

//sse的收藏接口
export const sseCollection = (data) => {
    return axios.request({
        method: "POST",
        url: '/zsg/collectCatalog/collect',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}

//最新稽查案例
export const newInspectData = (data) => {
    return axios.request({
        method: "POST",
        url: '/zsg/aiw/search',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}

//标签的子级
export const getTagTree = (data) => {
    return axios.request({
        method: "get",
        url: '/zsg/tag/tagTree',
        params: data,
        headers: { 'content-type': 'application/json' }
    })
}

//补贴检测查询公司
export const getCompanyList = (data) => {
    return axios.request({
        method: "get",
        url: '/zsg/ccw/getCompanyName',
        params: data,
        headers: { 'content-type': 'application/json' }
    })
}

//补贴检测公司匹配 获取详情
export const getCompanyDetail = (data) => {
    return axios.request({
        method: "get",
        url: '/zsg/ccw/fastEval',
        params: data,
        headers: { 'content-type': 'application/json' }
    })
}
//导出接口
export const getCompanyExport = (data) => {
    return axios.request({
        method: "get",
        url: '/zsg/ccw/fastEvalExport',
        params: data,
        headers: { 'content-type': 'application/json' }
    })
}

//获取风险检测列表
export const getRiskList = (data) => {
    return axios.request({
        method: "POST",
        url: '/zsg/risk-detection/open/list',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}
//添加企业列表
export const getAddRisk = (data) => {
    return axios.request({
        method: "POST",
        url: '/zsg/risk-detection/open',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}

//创建订单
export const getAuth = (data) => {
    return axios.request({
        method: "POST",
        url: '/zsg/risk-detection/auth',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}

//获取auth后的合理订单
export const getAuthOrder = (data) => {
    return axios.request({
        method: "POST",
        url: '/zsg/risk-detection/order/list',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}
//订单详情
export const getAuthOrderDetail = (data) => {
    return axios.request({
        method: "get",
        url: '/zsg/risk-detection/order/info',
        params: data,
        headers: { 'content-type': 'application/json' }
    })
}
//删除订单
export const getAuthOrderDelete = (data) => {
    return axios.request({
        method: "post",
        url: '/zsg/risk-detection/order/delete',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}


//山西接口
export const getMutexGetTree = (data) => {
    return axios.request({
        method: "post",
        url: '/sxssyhApi/mutex/getTree',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}
export const getMutexList = (data) => {
    return axios.request({
        method: "get",
        url: '/sxssyhApi/mutex/getMutexList',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}

export const getLawsFragment2 = (data) => {
    return axios.request({
        method: "post",
        url: '/sxssyhApi/retrieve/getLawsFragment2',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}
export const getExportPDF = (data) => {
    return axios.request({
        method: "post",
        url: '/sxssyhApi/retrieve/exportPDF',
        data: data,
        responseType: 'blob',
        headers: { 'content-type': 'application/json' }
    })
}

export const shanxiDetail = (data) => {
    return axios.request({
        method: "post",
        url: '/sxssyhApi/retrieve/detail',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}

export const newInspectListDetail = (data) => {
    return axios.request({
        method: "post",
        url: '/aiwCms/detail',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}

//收藏
export const getCollection = (data) => {
    return axios.request({
        method: "post",
        url: '/zsg/collectCatalog/myCollect',
        data: data,
        headers: { 'content-type': 'application/json' }
    })
}











